import ApplicationStore from '../stores/ApplicationStore';

export function login(context) {
  const appStore = context.getStore(ApplicationStore);
  const url = `${appStore.getDomainUrlDocs()}/auth/login`;
  context.trackEvent('click:auth0-docs:login');
  window.location = url;
}

export function signup(context) {
  const appStore = context.getStore(ApplicationStore);
  const url = appStore.getDomainUrlSignup();
  context.trackEvent('click:auth0-docs:signup');
  window.location = url;
}